import { call, put, takeEvery } from 'redux-saga/effects';
import {
  GET_SEBEL_USERS,
  ADD_SEBEL_USER,
  UPDATE_SEBEL_USER,
  DELETE_SEBEL_USER,
} from './actionTypes';

import {
  getSebelUsersSuccess,
  getSebelUsersFail,
  addSebelUserSuccess,
  addSebelUserFail,
  updateSebelUserSuccess,
  updateSebelUserFail,
  deleteSebelUserSuccess,
  deleteSebelUserFail,
  setSebelUserFieldErrors,
} from './actions';

import axiosInstance from 'pages/Utility/axiosInstance';
import toast from 'react-hot-toast';

// API calls
const fetchSebelUsersApi = () =>
  axiosInstance.get('', { params: { sp: 'usp_GetSabelUsers',id:null } });

const addSebelUserApi = ({user}) => axiosInstance.post('', user);

const updateSebelUserApi = ({user}) => axiosInstance.post('', user);

const deleteSebelUserApi = (id) =>
  axiosInstance.post('', { sp: 'usp_DeleteSabelUser', id: id });

// Sagas
function* getSebelUsersSaga() {
  try {
    const { data } = yield call(fetchSebelUsersApi);
    yield put(getSebelUsersSuccess(data));
  } catch (error) {
    yield put(getSebelUsersFail(error.response?.data || error.message));
  }
}

function* addSebelUserSaga(action) {
  try {
    const { data } = yield call(addSebelUserApi, action.payload);
    yield put(addSebelUserSuccess(data));
    toast.success('Siebel user added successfully!');
    action.payload.onClose();
    yield put({ type: GET_SEBEL_USERS });
  } catch (error) {
    if (error.response?.status === 400 && error.response?.data?.fieldErrors) {
      yield put(setSebelUserFieldErrors(error.response.data.fieldErrors));
    } else {
      yield put(addSebelUserFail(error.response?.data || error.message));
    }
  }
}

function* updateSebelUserSaga(action) {
  try {
    const { data } = yield call(updateSebelUserApi, action.payload);
    yield put(updateSebelUserSuccess(data));
    toast.success('Siebel user updated successfully!');
    action.payload.onClose();
    yield put({ type: GET_SEBEL_USERS });
  } catch (error) {
    if (error.response?.status === 400 && error.response?.data?.fieldErrors) {
      yield put(setSebelUserFieldErrors(error.response.data.fieldErrors));
    } else {
      yield put(updateSebelUserFail(error.response?.data || error.message));
    }
  }
}

function* deleteSebelUserSaga(action) {
  try {
    yield call(deleteSebelUserApi, action.payload);
    yield put(deleteSebelUserSuccess(action.payload));
    toast.success('Sebel user deleted successfully!');
    yield put({ type: GET_SEBEL_USERS });
  } catch (error) {
    yield put(deleteSebelUserFail(error.response?.data || error.message));
  }
}

// Watcher
function* sebelUserSaga() {
  yield takeEvery(GET_SEBEL_USERS, getSebelUsersSaga);
  yield takeEvery(ADD_SEBEL_USER, addSebelUserSaga);
  yield takeEvery(UPDATE_SEBEL_USER, updateSebelUserSaga);
  yield takeEvery(DELETE_SEBEL_USER, deleteSebelUserSaga);
}

export default sebelUserSaga;
